import React from 'react';
import { ZapIcon, ShieldCheckIcon, LayersIcon, SparklesIcon } from 'lucide-react';
export function WhyChooseUsSection() {
  const features = [{
    icon: <ZapIcon className="w-6 h-6 text-emerald-400" data-id="element-354" />,
    title: 'Performance Engineered',
    description: 'Every store and app we build is optimized for sub-second load times and maximum conversion rates.',
    glow: 'bg-emerald-500/20'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-blue-400" data-id="element-355" />,
    title: 'Shopify Native',
    description: "We don't hack workarounds. Our solutions follow Shopify's strict Liquid and App Bridge standards.",
    glow: 'bg-blue-500/20'
  }, {
    icon: <LayersIcon className="w-6 h-6 text-purple-400" data-id="element-356" />,
    title: 'Scalable Architecture',
    description: 'From ambitious startups to Shopify Plus enterprise brands, our code scales seamlessly with your GMV.',
    glow: 'bg-purple-500/20'
  }, {
    icon: <SparklesIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-357" />,
    title: 'Premium Aesthetics',
    description: 'We blend technical excellence with world-class design inspired by the best SaaS and luxury brands.',
    glow: 'bg-[#D4AF37]/20'
  }];
  return <section className="py-32 bg-[#020202] relative border-t border-white/5" data-id="element-358">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-359">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-360">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight" data-id="element-361">
            The Shopify Specialist Advantage
          </h2>
          <p className="text-xl text-gray-400" data-id="element-362">
            We don't build WordPress. We don't do generic web design. We
            engineer elite Shopify experiences.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-363">
          {features.map((feature, index) => <div key={index} className="group relative rounded-3xl bg-white/[0.02] border border-white/10 p-8 md:p-10 hover:bg-white/[0.04] transition-all duration-500 overflow-hidden" data-id="element-364">
              {/* Radial glow on hover */}
              <div className={`absolute -top-24 -right-24 w-64 h-64 ${feature.glow} rounded-full blur-[80px] opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none`} data-id="element-365" />

              <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center mb-8 border border-white/10 group-hover:scale-110 transition-transform duration-500 relative z-10" data-id="element-366">
                {feature.icon}
              </div>

              <div className="relative z-10" data-id="element-367">
                <h3 className="text-2xl font-bold text-white mb-4 tracking-tight" data-id="element-368">
                  {feature.title}
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-369">
                  {feature.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}